export enum WithdrawalType {
    Online = 'online',
    OnlinePix = 'onlinePix',
    Instant = 'instant',
    BankTransfer = 'bankTransfer',
    Shop = 'shop',
    PaySafeCard = 'paySafeCard',
    Transaks = 'transaks',
    PaymentIQ = 'paymentIQ',
}

// TODO: This and Withdrawal type also exist in the config lib, fix
export enum DepositType {
    Online = 'online',
    BankTransfer = 'bankTransfer',
    Shop = 'shop',
    Aircash = 'aircash',
    PaySafeCard = 'paySafeCard',
    PaySpot = 'paySpot',
    Transaks = 'transaks',
    OnlinePix = 'onlinePix',
    Bancontact = 'bancontact',
    PaymentIQ = 'paymentIQ',
}

export enum NotificationType {
    idCard = 'idCard',
    completeRegistration = 'completeRegistration',
    sms = 'sms',
    lowBalance = 'lowBalance',
    idCardVerificationPending = 'idCardVerificationPending',
    idCardVerificationApproved = 'idCardVerificationApproved',
}

export enum PlayerDetailsFieldType {
    kycChecked = 'kycChecked',
    shouldVerifySms = 'shouldVerifySms',
    hasMadeDeposit = 'hasMadeDeposit',
    firstDepositDate = 'firstDepositDate',
    phone = 'phone',
    communication = 'communication',
    reKycStatus = 'reKycStatus',
}

export const PushMessageType = {
    KYCStatusChangedToPassed: 'KYCStatusChangedToPassed',
    WithdrawalStatusChangesToPaid: 'WithdrawalStatusChangesToPaid',
    BonusIsAwarded: 'BonusIsAwarded',
    EligibleForCampaign: 'EligibleForCampaign',
    BonusAbuser: 'BonusAbuser',
    NewBonus: 'NewBonus',
    ExpiredBonus: 'ExpiredBonus',
    CompletedBonus: 'CompletedBonus',
    TermsUpdate: 'TermsUpdate',
    RealityCheck: 'RealityCheck',
    AlertMessage: 'AlertMessage',
    BrazilMigrationTerms: 'BrazilMigrationTerms',
} as const;

export type PushMessageType = typeof PushMessageType[keyof typeof PushMessageType];
